var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1A77F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7639 10.6171H21.45V7H18.2924V7.01304C14.4664 7.13657 13.6823 9.09711 13.6131 11.1563H13.6053V12.9625H11V16.5048H13.6053V26H17.5316V16.5048H20.7478L21.3692 12.9625H17.5329V11.8712C17.5329 11.1753 18.0408 10.6171 18.7639 10.6171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ba7e3d6b13d32d0bfdb3a7eaa7ffc222.svg";
export { ForwardRef as ReactComponent };